import create from 'zustand';

const USER_PROFILE_INITIAL = {
	user: {
		id: 0,
		avatar: '',
		name: '',
		surname: '',
		fullName: '',
		email: '',
		gender: '',
		personalCode: '',
		phoneNumber: '',
		role: '',
		status: '',
		online: false,
		lastOnline: ''
	},
	address: {
		id: 0,
		country: '',
		city: '',
		street: '',
		zip: ''
	}
};

export const useUserProfileStore = create(set => ({
	...USER_PROFILE_INITIAL,

	// Initialize user's state
	onInit: (user) => set((state) => ({
		user: {
			id: user?.id,
			avatar: user?.avatar,
			name: user?.name,
			surname: user?.surname,
			fullName: user?.fullName,
			email: user?.email,
			gender: user?.gender,
			personalCode: user?.personalCode,
			phoneNumber: user?.phoneNumber,
			role: user?.role,
			status: user?.status,
			online: user?.online,
			lastOnline: user?.lastOnline
		},
		address: user?.address ? {
			id: user.address.id,
			country: user.address.country,
			city: user.address.city,
			street: user.address.street,
			zip: user.address.zip
		} : {
			...state.address
		},
	})),

	// Update user's state
	onUpdate: (user) => set(state => ({
		user: {
			...state.user,
			...user
		}
	})),

	// Update user's address state
	onUpdateAddress: (address) => set(state => ({
		address: {
			...state.address,
			...address
		}
	})),

	// Reset store to initial state
	onReset: () => set({
		...USER_PROFILE_INITIAL
	})
}));